import { render, staticRenderFns } from "./AddWebhookDialog.vue?vue&type=template&id=6638759a&"
import script from "./AddWebhookDialog.vue?vue&type=script&lang=ts&"
export * from "./AddWebhookDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports